import _ from 'underscore';
import { I9nSchemaBySystem } from '@biteinc/common';
// TODO: replace with fields from the I9nDiningOption ts type
export const i9nTenderTypeFields = [
    'visaTenderTypeID',
    'masterCardTenderTypeID',
    'discoverTenderTypeID',
    'amExTenderTypeID',
    'interacTenderTypeID',
    'otherTenderTypeID',
    'cashTenderTypeID',
    'giftCardTenderTypeID',
];
export function getSearchTokensWithTypes(types, includeToken) {
    const tokens = Object.values(I9nSchemaBySystem)
        .filter((i9nSchema) => {
        return (!i9nSchema.isDeprecated &&
            types.includes(i9nSchema.type) &&
            !i9nSchema.name.includes('Pinata'));
    })
        .flatMap((i9nSchema) => {
        return i9nSchema.searchTokens.map((token) => `:${token}`);
    });
    if (includeToken) {
        tokens.push(includeToken);
    }
    return _.uniq(tokens).sort();
}
export function systemCanBeSynced(system) {
    const i9nSchema = I9nSchemaBySystem[system];
    switch (i9nSchema.type) {
        case 'pos':
            return true;
        case 'campus-card':
        case 'kiosk-payment':
        case 'loyalty':
        case 'sms-notifier':
        case 'fulfillment':
        case 'stored-value':
            return !!i9nSchema.canSync;
        case 'cash-machine':
        case 'comp-card':
        case 'ecomm-payment':
        case 'loyalty-earner':
        case 'marketing':
        case 'pos-data-source':
        case 'supplementary-menu-source':
        case 'table-tracker':
            return false;
    }
}
//# sourceMappingURL=i9n_helper.js.map